<template>
  <div class="photo-wall" :style="{'background-image':'url('+imgUrls[selectedIndex]+')'}">
    <div class="title" v-if="coverLetter.length > 0">{{coverLetter}}</div>
    <div
      class="photo-preview"
      v-for="(url,i) in imgUrls"
      v-if="!autoDisplay"
      v-show="i!=selectedIndex"
      :style="{'background-image':'url('+url+')'}"
      @click="selectImage(i)"
    />
  </div>
</template>

<script>
import { clearInterval } from "timers";
export default {
  props: {
    imgUrls: {
      type: Array,
      required: false,
      default() {
        return [
          "https://images.unsplash.com/photo-1551776235-dde6d482980b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80"
        ];
      }
    },
    autoDisplay: {
      type: Boolean,
      required: false,
      default: false
    },
    coverLetter: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      selectedIndex: 0,
      setIntervalID: undefined
    };
  },
  mounted() {
    this.setIntervalID = setInterval(() => {
      this.carousel();
    }, 2000);
  },
  destroyed() {
    if (this.setIntervalID) {
      window.clearInterval(this.setIntervalID);
    }
  },
  methods: {
    selectImage(i) {
      this.selectedIndex = i;
    },
    carousel() {
      if (this.autoDisplay) {
        this.selectedIndex = (this.selectedIndex + 1) % this.imgUrls.length;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.photo-wall {
  width: 100%;
  height: calc(100vh - var(--bannerHeight));
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: cover;
  transition: background-image 1s;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
  align-items: flex-end;
  position: relative;
  padding: var(--g-xl);
}
.photo-preview {
  &:hover {
    cursor: pointer;
    opacity: 1;
  }
  min-width: 135px;
  min-height: 90px;
  margin-left: var(--g-m);
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: cover;
  opacity: 0.5;
  transition: opacity 0.5s;
}

.title {
  position: absolute;
  top: calc((100vh - var(--bannerHeight)) * 0.5);
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  font-size: var(--fs-xxl);
  font-weight: bold;
  background-color: white;
  box-shadow: 0 0 10px var(--text-color-darker) inset;
  padding: var(--g-l) var(--g-xxl);
}
</style>